export const WidgetUrl = {
  project: {
    view: id => `/project/view/${id}`,
    edit: id => `/project/edit/${id}`,
  },

  supportTicket: {
    view: id => `/support/ticket/${id}`,
  },

  quote: {
    view: (customerId, opportunityId, id) =>
      `/crm/${customerId}/${opportunityId}/quote/view/${id}`,
    edit: (customerId, opportunityId, id) =>
      `/crm/${customerId}/${opportunityId}/quote/edit/${id}`,
  },

  chargeback: {
    projectChargebackViewUrl: secondaryId => `/project/view/${secondaryId}`,
    projectChargebackEditUrl: additionalDetails =>
      `/project/edit/${additionalDetails}`,
    chargebackViewUrl: id => `/project/chargeback/view/chargeback/${id}`,
    chargebackEditUrl: id => `/project/chargeback/edit/chargeback/${id}`,
  },

  lead: {
    view: (customerId, leadId) =>
      `/crm/${customerId}/opportunity/view/${leadId}`,
    edit: (customerId, leadId) =>
      `/crm/${customerId}/opportunity/edit/${leadId}`,
  },
};
